import { atom } from "recoil";

import {
  CoursesCalendarRideStatusFilter,
  CoursesCalendarRowsFilter,
  ICoursesCalendarSlotDto,
} from "../../models/courses-calendar.models";

export const coursesCalendarRideStatusFilterAtom =
  atom<CoursesCalendarRideStatusFilter>({
    key: "coursesCalendarRideStatusFilterAtom",
    default: "all",
  });

/** Last fetched slots for the courses calendar (used by selection toolbar / produce). */
export const coursesCalendarSlotsAtom = atom<ICoursesCalendarSlotDto[]>({
  key: "coursesCalendarSlotsAtom",
  default: [],
});

export const selectedCoursesCalendarSlotIdsAtom = atom<Set<string>>({
  key: "selectedCoursesCalendarSlotIdsAtom",
  default: new Set(),
});

/** Controls which hour rows and course slots are shown on the calendar. */
export const coursesCalendarRowsFilterAtom = atom<CoursesCalendarRowsFilter>({
  key: "coursesCalendarRowsFilterAtom",
  default: "all",
});
